import React, { useState, useEffect, useCallback } from 'react';
import { useTerminaltore } from '../../store/TerminaisStores';
import { Paper, Typography, Box, Stack, Pagination } from '@mui/material';

// Importando os componentes filhos
import FiltrosBusca from '../../components/FiltroBuscaDeMaquinas';
import TabelaMaquinas from '../../components/TabelaMaquinas';
import ModalEdicao from '../../components/ModalEdicaoMaquinas';
import ModalNovaMaquina from '../../components/ModalAddNovaMaquina';


export default function MaquinasPage() {
    // Pegando estado e ações da store
    const {
        terminais,
        paginaAtual,
        ultimaPagina,
        loading,
        deletingId,
        fetchTerminais,
        searchTerminais,
        deleteTerminal,
        updateTerminal,
        CreateTerminal
    } = useTerminaltore();

    // Estado local para controlar o modal de edição
    const [modalAberto, setModalAberto] = useState(false);
    const [modalCriacaoAberto, setmodalCriacaoAberto] = useState(false);
    const [terminalSelecionado, setTerminalSelecionado] = useState(null);

    // Busca inicial dos dados quando o componente é montado
    useEffect(() => {
        fetchTerminais();
    }, [fetchTerminais]);

    // Funções de callback otimizadas com useCallback
    const handleBusca = useCallback((filtros) => {
        searchTerminais(filtros);
    }, [searchTerminais]);

    const handleLimparBusca = useCallback(() => {
        fetchTerminais(1); // Volta para a primeira página ao limpar
    }, [fetchTerminais]);

    const handleAbrirModal = useCallback((terminal) => {
        setTerminalSelecionado(terminal);
        setModalAberto(true);
    }, []);

    const handleFecharModal = useCallback(() => {
        setModalAberto(false);
        setTerminalSelecionado(null);
    }, []);

    const handleFecharModalCriacao = useCallback(() => {
        setmodalCriacaoAberto(false);
    }, [])

    const handleAbrirModalCriacao = useCallback(() => {
        setmodalCriacaoAberto(true);
    }, [])

    const handleSalvarEdicao = useCallback(async (dadosTerminal) => {
        await updateTerminal(dadosTerminal);
        handleFecharModal();
    }, []);


    const handleSalvarCriacao = useCallback(async (dadosTerminal) => {
        await CreateTerminal(dadosTerminal);
        handleFecharModalCriacao();

    }, []);

    const handleExcluir = useCallback((terminalId) => {
        deleteTerminal(terminalId);
    }, [deleteTerminal]);

    const handlePageChange = useCallback((event, page) => {
        fetchTerminais(page);
    }, [fetchTerminais]);

    return (
        <Paper elevation={3} sx={{ p: 3, borderRadius: 3, width: '99%', backgroundColor: 'transparent' }}>
            <Typography variant="h5" component="h1" gutterBottom>
                Gerenciamento de Máquinas
            </Typography>

            <FiltrosBusca
                onSearch={handleBusca}
                onClear={handleLimparBusca}
                oncreate={handleAbrirModalCriacao}

            />

            <Box sx={{ mt: 4 }}>
                <TabelaMaquinas
                    terminais={terminais}
                    onEdit={handleAbrirModal}
                    onDelete={handleExcluir}
                    loadingState={{ loading, deletingId }}
                />
            </Box>

            <Stack spacing={2} sx={{ mt: 3, alignItems: 'center' }}>
                <Pagination
                    page={paginaAtual}
                    count={ultimaPagina}
                    onChange={handlePageChange}
                    color="primary"
                    shape="rounded"
                    disabled={loading !== 'idle'}
                />
            </Stack>

            {/* MODAL DE EDIÇÃO */}
            {modalAberto && (
                <ModalEdicao
                    open={modalAberto}
                    onClose={handleFecharModal}
                    onSave={handleSalvarEdicao}
                    terminal={terminalSelecionado}
                    isLoading={loading === 'updating'}
                />
            )}

            {/* MODAL DE CRIACAO */}
            {ModalNovaMaquina && (
                <ModalNovaMaquina
                    open={modalCriacaoAberto}
                    onClose={handleFecharModalCriacao}
                    onSave={handleSalvarCriacao}
                    isLoading={loading !== 'idle'}
                />
            )}

        </Paper>
    );
}